import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from "react";
import styled from "styled-components";
import axios from "axios";

import { Control } from "components/ui-kit/control";

export default function UniVisibilitySwitcher(props) {
    const {
        dbClassName = "University",
        id,
        field = "hideFromAll",
        label = "Скрыть всю информацию ВУЗа"
    } = props;

    const [saving, setSaving] = useState(false);

    const [data, setData] = useState(undefined);

    useEffect(() => {
        axios.get(`/tools/data/clName/${dbClassName}/${id}/field/${field}`).then(d => {
            setData(d.data);
        });
    }, [dbClassName, id, field]);

    if (data == undefined) {
        return "...";
    }

    let value = (data.value == undefined ? false : data.value);

    return (
        <Wrapper>
            <Control.Checkbox
                checked={value}
                placeholder={""}
                label={saving == true ? 'Сохраняем данные...' : label}
                onClick={async () => {
                    let newVal = !value;
                    setSaving(true);
                    await axios.post(`/tools/data/clName/${dbClassName}/${id}/field/${field}`, { value: newVal });
                    let dd = (await axios.get(`/tools/data/clName/${dbClassName}/${id}/field/${field}`)).data;
                    setData(dd);
                    setSaving(false);
                }}
            />
        </Wrapper>
    );
}

const Wrapper = styled.div`

`;